// labelDisplay.ts
export type PartLabelDisplay = {
  widthCm?: number;
  heightCm?: number;

  tagNo: boolean;
  logo: boolean;
  date: boolean;

  makeModelCategoryLine: boolean;

  qr: boolean;
  price: boolean;

  vehicleStack: {
    make: boolean;
    model: boolean;
    vrm: boolean;
    year: boolean;
    engineCode: boolean;
    vin: boolean;
    fuelType: boolean;
  };

  position: boolean;
  qc: boolean;
  imaged: boolean;
};

export const defaultPartLabelDisplay: PartLabelDisplay = {
  widthCm: 10,
  heightCm: 5,

  tagNo: true, // not this
  logo: true,
  date: true, // created date not just date

  makeModelCategoryLine: true, // not this

  qr: true, // not this
  price: true,

  vehicleStack: {
    make: true,
    model: true,
    vrm: true,
    year: true,
    engineCode: true,
    vin: true,
    fuelType: true
  },

  position: true,  // not this
  qc: true,        // not this
  imaged: true     // not this
};
